export const USER='user';
export const AUTHTOKEN='token';
export const ISACTIVE='isActive'
export const S3_BASE_URL= "https://dflzczhyxe8dk.cloudfront.net/"
